import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  AccountCircle,
  Add,
  Circle,
  Dashboard,
  DownloadForOffline,
  Facebook,
  Favorite,
  FilterList,
  Logout,
  Redeem,
  Search,
  Share,
  ShoppingCart,
  Star,
  Twitter,
  VpnKey,
  WhatsApp,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Container,
  Grid,
  IconButton,
  InputLabel,
  Rating,
  TextField,
  Tooltip,
} from "@mui/material";

import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import DateAdapter from "@mui/lab/AdapterMoment";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { AddressCard, BasicCard, SupplierCards } from "components";
import { ReferBanner } from "asset";
import { db, useClickArea, useIsMounted } from "hooks";
import { PasswordChange } from "pages";
import useDataFetch, {
  useProducts,
  useSuppliers,
  useWishlistData,
} from "hooks/useDataFetch";
import { signOut, updateProfile } from "firebase/auth";
import { auth, database } from "configs/firebaseConfigs";
import { useAppContext } from "contexts";
import Lottie from "react-lottie";
import { emptyList } from "asset/animations";
import Swal from "sweetalert2";
import moment from "moment";
import { formatCurrency, getArrFromObj } from "@ashirbad/js-core";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-number-input";
import { onValue, ref } from "firebase/database";

const MyProfile = () => {
  const { user } = useAppContext();
  const [birthDate, setBirthDate] = useState(null);
  const [name, setName] = useState(user?.displayName);
  const [addressType, setAddressType] = useState("home");

  const addNewAddressRef = useRef(null);
  const [addNewAddress, setNewAddress] = useState(false);

  useClickArea(addNewAddressRef, () => {
    setNewAddress(false);
  });

  const [changePassword, setChangePassword] = useState(false);

  // console.log(changePassword);

  // console.log(user);

  const saveProfile = async () => {
    try {
      const user = auth.currentUser;
      await updateProfile(user, {
        displayName: name,
      });
      await db.updateDb(`users/${user?.uid}`, {
        displayName: name,
        dateOfBirth: birthDate,
      });
      Swal.fire({
        title: "Success",
        text: "Profile updated successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: "",
      lastName: "",
      contactNo: "",
      address: "",
      city: "",
      landmark: "",
      country: "",
      postalCode: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string(),
      contactNo: Yup.string().required("Contact number is required"),
      address: Yup.string().required("Address is required"),
      city: Yup.string().required("City is required"),
      landmark: Yup.string(),
      country: Yup.string().required("Country is required"),
      postalCode: Yup.string().required("Postal code is required"),
    }),
    onSubmit: async (values, submitProps) => {
      try {
        // console.log(values);
        const address = {
          firstName: values?.firstName,
          lastName: values?.lastName,
          address: values?.address,
          landmark: values?.landmark,
          city: values?.city,
          country: values?.country,
          postalCode: values?.postalCode,
          addressType: addressType,
          default: false,
          contactNo: values?.contactNo,
        };
        await db.pushData("users/" + user?.uid + "/address", address);
        Swal.fire({
          title: "Success",
          text: "Address added successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        submitProps.resetForm();
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    },
  });

  return (
    <div className="user-profile-personal">
      {changePassword && (
        <PasswordChange
          changeState={(value) => {
            setChangePassword(value);
          }}
        />
      )}
      <h1 className="user-profile-personal-title">My Profile</h1>

      <div className="user-profile-personal-details">
        <span className="user-profile-personal-details-title flex-row align-items-center justify-content-between ">
          <span>Personal Information</span>
          <span
            className="flex-row gap-1 align-items-center profile-change-password"
            onClick={() => {
              setChangePassword(true);
            }}
          >
            <VpnKey /> Change Password
          </span>
        </span>
        <Grid container spacing={2}>
          <Grid item md={4} xs={12}>
            <p className="user-profile-personal-desc">
              Edit your personal information and settings.
            </p>
          </Grid>
          <Grid item md={8} xs={12}>
            <div className="user-personal-update-form flex-column gap-1">
              <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                <span className="flex-column gap-1">
                  <InputLabel>Name</InputLabel>
                  <TextField
                    placeholder="Name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </span>
                <span className=" user-personal-update-form-dob  flex-column gap-1">
                  <InputLabel>Birth Date</InputLabel>

                  <LocalizationProvider dateAdapter={DateAdapter}>
                    <DatePicker
                      value={user?.dateOfBirth || birthDate}
                      disableFuture
                      onChange={(newValue) => {
                        let date = moment(newValue).format("L");
                        setBirthDate(date);
                      }}
                      renderInput={(params) => (
                        <>
                          <TextField {...params} />
                        </>
                      )}
                    />
                  </LocalizationProvider>
                </span>
              </span>

              <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                <span className="flex-column gap-1">
                  <InputLabel>Phone No</InputLabel>
                  <TextField
                    placeholder=" Phone No"
                    disabled
                    value={user?.phoneNumber}
                  />
                </span>
                <span className="flex-column gap-1">
                  <InputLabel>Email</InputLabel>
                  <TextField placeholder="Email" disabled value={user?.email} />
                </span>
              </span>

              <span className="personal-info-save-btn flex-row gap-2 align-items-center">
                <Button onClick={saveProfile}>Save</Button>
                {/* <Button>Edit</Button> */}
              </span>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="user-profile-personal-details">
        <p className="user-profile-personal-details-title">Saved Addresses</p>
        <Grid container spacing={2}>
          <Grid item md={4} xx={12}>
            <p className="user-profile-personal-desc">
              Choose your preferred delivery address or edit them.
            </p>
          </Grid>
          <Grid item md={8} xs={12}>
            <div className="profile-saved-address-main" ref={addNewAddressRef}>
              <Button
                className="profile-add-new-address flex-row align-items-center gap-1 w-100"
                onClick={() => {
                  setNewAddress(!addNewAddress);
                }}
              >
                <Add /> <span> Add a new address </span>
              </Button>

              {addNewAddress ? (
                <form
                  onSubmit={formik.handleSubmit}
                  className="user-personal-update-form flex-column gap-1"
                >
                  <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                    <span className="flex-column gap-1">
                      <InputLabel>First Name</InputLabel>
                      <TextField
                        placeholder="e.g - Sahrukh "
                        name="firstName"
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.firstName && formik.errors.firstName
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.firstName && formik.errors.firstName
                            ? formik.errors.firstName
                            : null
                        }
                      />
                    </span>
                    <span className="flex-column gap-1">
                      <InputLabel>Last Name</InputLabel>
                      <TextField
                        placeholder="e.g - Khan "
                        name="lastName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                        error={
                          formik.touched.lastName && formik.errors.lastName
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.lastName && formik.errors.lastName
                            ? formik.errors.lastName
                            : null
                        }
                      />
                    </span>
                  </span>
                  <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                    <span className=" user-personal-update-form-dob  flex-column gap-1">
                      <InputLabel>Postal Code</InputLabel>

                      <TextField
                        type={"number"}
                        placeholder="e.g - 123456 "
                        name="postalCode"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.postalCode}
                        error={
                          formik.touched.postalCode && formik.errors.postalCode
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.postalCode && formik.errors.postalCode
                            ? formik.errors.postalCode
                            : null
                        }
                      />
                    </span>
                    <span className="flex-column gap-1">
                      <InputLabel>Contact No</InputLabel>
                      <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        className="w-100 country-phone-input-address flex-row align-items-center "
                        placeholder="e.g - 1234567890 "
                        value={formik.values.contactNumber}
                        onChange={(value) => {
                          formik.setFieldValue("contactNo", value);
                        }}
                        onBlur={(value) => {
                          formik.handleBlur("contactNo");
                        }}
                        defaultCountry="IN"
                      />
                    </span>
                  </span>
                  <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                    <span className="flex-column gap-1">
                      <InputLabel>Address</InputLabel>
                      <TextField
                        placeholder="e.g - 123, Main Street, Riyadh  "
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.address && formik.errors.address
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.address && formik.errors.address
                            ? formik.errors.address
                            : null
                        }
                      />
                    </span>
                    <span className="flex-column gap-1">
                      <InputLabel>Landmark</InputLabel>
                      <TextField
                        placeholder="Locality"
                        name="landmark"
                        value={formik.values.landmark}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.landmark && formik.errors.landmark
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.landmark && formik.errors.landmark
                            ? formik.errors.landmark
                            : null
                        }
                      />
                    </span>
                  </span>

                  <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                    <span className="flex-column gap-1">
                      <InputLabel>City</InputLabel>
                      <TextField
                        placeholder="e.g - Riyadh "
                        name="city"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.city}
                        error={
                          formik.touched.city && formik.errors.city
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.city && formik.errors.city
                            ? formik.errors.city
                            : null
                        }
                      />
                    </span>
                    <span className="flex-column gap-1">
                      <InputLabel>Country</InputLabel>
                      <TextField
                        placeholder="Country"
                        name="country"
                        value={formik.values.country}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.country && formik.errors.country
                            ? true
                            : false
                        }
                        helperText={
                          formik.touched.country && formik.errors.country
                            ? formik.errors.country
                            : null
                        }
                      />
                    </span>
                  </span>
                  <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                    <span className="flex-column gap-1">
                      <InputLabel>Address Type</InputLabel>
                      <div className="flex-row gap-2">
                        <span className="flex-row gap-1 align-items-center">
                          <Checkbox
                            checked={addressType === "home"}
                            onChange={() => {
                              setAddressType("home");
                            }}
                          />
                          <p>Home</p>
                        </span>
                        <span className="flex-row gap-1 align-items-center">
                          <Checkbox
                            checked={addressType === "office"}
                            onChange={() => {
                              setAddressType("office");
                            }}
                          />
                          <p>Office</p>
                        </span>
                      </div>
                    </span>
                  </span>
                  <span className="personal-info-save-btn flex-row align-items-center gap-2 ">
                    <Button type="submit">Save</Button>
                    <Button
                      onClick={() => {
                        setNewAddress(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </span>
                </form>
              ) : (
                <div className="profile-all-saved-address flex-column gap-1">
                  {user?.address
                    ? getArrFromObj(user?.address)?.map((address, index) => {
                        return <AddressCard address={address} key={index} />;
                      })
                    : "No saved address"}
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
      {/* mobile card */}

      {/* <div className="user-profile-personal-details">
        <p className="user-profile-personal-details-title">Saved Card</p>
        <Grid container spacing={2}>
          <Grid item md={4} xx={12}>
            <p className="user-profile-personal-desc">
              Saved card details for super fast checkout.
            </p>
          </Grid>
          <Grid item md={8} xs={12}>
            {addNewCard ? (
              <div
                className="user-personal-update-form flex-column gap-1"
                ref={cardRef}
              >
                <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
                  <span className="flex-column gap-1">
                    <InputLabel>Card Number </InputLabel>
                    <TextField placeholder="Card Number" />
                  </span>
                  <span className="flex-column gap-1">
                    <InputLabel>Valid Thru</InputLabel>
                    <TextField placeholder="Valid Thru" />
                  </span>
                </span>
                <span className="flex-column gap-1 w-100 ">
                  <InputLabel>Card Holder Name </InputLabel>
                  <TextField placeholder="Card Holder " />
                </span>
                <span className=" user-personal-update-form-dob  flex-column gap-1">
                  <InputLabel>CVV code</InputLabel>

                  <TextField placeholder="CVV" />
                </span>

                <span className="personal-info-save-btn flex-row align-items-center gap-2 ">
                  <Button>Save</Button>
                  <Button
                    onClick={() => {
                      setNewCard(false);
                    }}
                  >
                    Cancel
                  </Button>
                </span>
              </div>
            ) : (
              <div className="profile-saved-card-main flex-row gap-1 flex-wrap justify-content-between">
                <div className="profile-saved-card-shape flex-column justify-content-between">
                  <div className="saved-card-holder-name">Bill Gates</div>

                  <div className="saved-card-number">xxxx-xxxx-xxxx-7777</div>

                  <div className="saved-card-details flex-row align-items-center justify-content-between ">
                    <span className="saved-card-valid-date">
                      Valid Thru : 12/22
                    </span>

                    <span className="saved-card-brand">
                      <img src={VisaIcon} alt="" />
                    </span>
                  </div>
                </div>
                <div className="profile-saved-card-shape flex-column justify-content-between">
                  <div className="saved-card-holder-name">Elon Musk</div>

                  <div className="saved-card-number">xxxx-xxxx-xxxx-6666</div>

                  <div className="saved-card-details flex-row align-items-center justify-content-between ">
                    <span className="saved-card-valid-date">
                      Valid Thru : 12/24
                    </span>

                    <span className="saved-card-brand">
                      <img src={MaestroIcon} alt="" />
                    </span>
                  </div>
                </div>
                <div
                  className="blank-add-card flex-row align-items-center justify-content-center"
                  onClick={() => {
                    setNewCard(!addNewCard);
                  }}
                >
                  <span className="add-card-icon">
                    <Add />
                  </span>
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </div> */}
    </div>
  );
};

const MyOrder = () => {
  const [orderedData, setOrderedData] = useState([]);

  const [searchedTerm, setSearchedTerm] = useState("");

  const [orderStatus, setOrderStatus] = useState("");

  const [orderTime, setOrderTime] = useState(0);

  const [filteredProduct, setFilteredProduct] = useState([]);

  const [reviewMessage, setReviewMessage] = useState("");

  const [reviewId, setReviewId] = useState("");

  // console.log(searchedTerm);

  const { user } = useAppContext();

  const orders = useDataFetch(`orders/${user?.uid}`);

  // console.log(orders?.data);
  // console.log(orderedData);

  const isMounted = useIsMounted();
  const navigate = useNavigate();

  useEffect(() => {
    if (isMounted.current) {
      if (!orders?.data) {
        return;
      }

      let array = [];
      let sl = 1;

      orders?.data?.map((order) => {
        return order?.products?.map((product) => {
          array.push({
            ...order,
            products: product,
            sl: sl,
          });
          sl++;
          return array;
        });
      });

      setOrderedData(array);
    }
  }, [orders?.data, isMounted]);

  // console.log(orderedData);

  const rateRef = useRef(null);

  const [rateOrder, setRateOrder] = useState(false);
  useClickArea(rateRef, () => {
    setRateOrder(false);
  });

  const [rateValue, setRateValue] = useState(0);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: emptyList,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const searchOrder = () => {
    try {
      let filteredData = orderedData?.filter((order) => {
        return order?.products?.productName
          ?.toLowerCase()
          .includes(searchedTerm);
      });
      // console.log(filteredData);
      setFilteredProduct(filteredData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isMounted.current) {
      const filteredOrderedStatus = orderedData?.filter((order) => {
        if (orderStatus) {
          return order?.status === orderStatus;
        }
        return order;
      });
      const filterOrderYear =
        filteredOrderedStatus
          ?.filter((order) => {
            if (orderTime === 30) {
              return (
                moment(order?.createdAt).valueOf() >
                moment().subtract(30, "d").valueOf()
              );
            } else if (orderTime === 365) {
              return (
                moment(order?.createdAt).valueOf() >
                moment().subtract(365, "d").valueOf()
              );
            } else if (orderTime === 730) {
              return (
                moment(order?.createdAt).valueOf() >
                moment().subtract(730, "d").valueOf()
              );
            } else {
              return filteredOrderedStatus;
            }
          })
          .sort((a, b) => {
            return b.createdAt - a.createdAt;
          }) || filteredOrderedStatus;
      setFilteredProduct(filterOrderYear);
    }
  }, [isMounted, orderedData, orderTime, orderStatus]);
  // console.log(user);

  const handleReview = async () => {
    try {
      // console.log(reviewId);
      if (!reviewId) return;

      await db.setData(`reviews/${reviewId}/${user?.uid}`, {
        review: reviewMessage,
        user: {
          uid: user?.uid,
          displayName: user?.displayName || "",
          photoURL: user?.photoURL || "",
        },
        rating: rateValue,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      });

      onValue(ref(database, `products/${reviewId}`), async (snapshot) => {
        if (snapshot.exists()) {
          let product = Object.values(snapshot.val());
          let reviewCount = product[0].reviews + 1;
          let rating = (product[0].rating + rateValue / 2).toFixed(2);
          await db.updateDb(`products/${reviewId}`, {
            reviews: reviewCount,
            rating: rating,
          });
          onValue(
            ref(database, `suppliers/${product?.supplierId}`),
            (snapshot) => {
              if (snapshot.exists()) {
                let supplier = Object.values(snapshot.val());
                let supplierRating = (
                  supplier[0].rating +
                  rateValue / 2
                ).toFixed(2);
                let supplierReviewCount = supplier[0].reviews + 1;
                db.updateDb(`suppliers/${product?.supplierId}`, {
                  reviews: supplierReviewCount,
                  rating: supplierRating,
                });
              }
            }
          );
        }
      });

      Swal.fire({
        icon: "success",
        title: "Review Submitted",
        text: "Thank you for your review",
      });
      setRateValue(0);
      setReviewMessage("");
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
      });
    }
  };

  // console.log(orderedData);

  return (
    <section className="profile-my-order-section">
      <div className="profile-my-order-filter-section">
        <Accordion>
          <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
            <div className="profile-my-order-filter-section-title flex-row align-items-center gap-1">
              <FilterList />

              <h3>Filters</h3>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="profile-my-order-filter-outer flex-column gap-2">
              <div className="filter-by-order-status">
                <h3 className="filter-order-title">Order Status</h3>
                <div className="filter-order-status-inner">
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderStatus === "pending"}
                      onClick={() => {
                        setOrderStatus("pending");
                      }}
                    />{" "}
                    <p> On the way </p>
                  </span>
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderStatus === "delivered"}
                      onClick={() => {
                        setOrderStatus("delivered");
                      }}
                    />{" "}
                    <p> Delivered </p>
                  </span>
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderStatus === "cancelled"}
                      onClick={() => {
                        setOrderStatus("cancelled");
                      }}
                    />{" "}
                    <p> Cancelled </p>
                  </span>
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderStatus === "packed"}
                      onClick={() => {
                        setOrderStatus("packed");
                      }}
                    />{" "}
                    <p> Packed </p>
                  </span>
                </div>
              </div>
              <div className="filter-by-order-time">
                <h3 className="filter-order-title">Order Time</h3>
                <div className="filter-order-time-inner">
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderTime === 30}
                      onClick={() => {
                        setOrderTime(30);
                      }}
                    />{" "}
                    <p> Last 30 days </p>
                  </span>
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderTime === 365}
                      onClick={() => {
                        setOrderTime(365);
                      }}
                    />{" "}
                    <p> 2022 </p>
                  </span>
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderTime === 730}
                      onClick={() => {
                        setOrderTime(430);
                      }}
                    />{" "}
                    <p> 2021 </p>
                  </span>
                  <span className="flex-row align-items-center">
                    <Checkbox
                      checked={orderTime === "older"}
                      onClick={() => {
                        setOrderTime("older");
                      }}
                    />{" "}
                    <p> Older </p>
                  </span>
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>

      <div className="my-order-search-bar w-100 flex-row align-items-center ">
        <TextField
          placeholder="Search your orders here"
          className="my-order-search-bar-input w-100 "
          value={searchedTerm}
          onChange={(e) => {
            setSearchedTerm(e?.target?.value);
          }}
        />
        <Button
          className="my-order-search-btn flex-row align-items-center gap-1 "
          onClick={searchOrder}
        >
          <Search />
          Search Order
        </Button>
      </div>
      <div className="my-order-items flex-column gap-2">
        {filteredProduct && filteredProduct?.length > 0 ? (
          filteredProduct?.map((order, index) => {
            return (
              <React.Fragment key={index}>
                <div className="my-order-child flex-row  justify-content-between ">
                  <div className="order-child-left flex-row  gap-2">
                    <div className="order-child-img">
                      <img src={order?.products?.productImg} alt="" />
                    </div>
                    <div className="order-child-details flex-column gap-1">
                      <div className="order-child-details-title">
                        <h3>{order?.products?.productName}</h3>
                      </div>

                      <div className="order-item-quantity-details flex-column gap-1">
                        <span className="order-item-supplier flex-row align-items-center gap-2">
                          <span className="flex-row align-items-center gap-1">
                            Quantity : <p> {order?.products?.orderedQty} </p>
                          </span>
                          <span className="flex-row align-items-center gap-1">
                            Supplier : <p> {order?.products?.supplierName} </p>
                          </span>
                        </span>
                        <span className="order-item-pricing-details flex-row align-items-center gap-1">
                          Price :{" "}
                          <p>
                            {formatCurrency(
                              order?.products?.price *
                                order?.products?.orderedQty,
                              "SAR"
                            )}
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="order-child-right flex-column gap-1">
                    <div className="order-child-delivery-update flex-row align-items-center gap-1  ">
                      <Circle
                        sx={{
                          color: `${order?.delivered ? "#0a830a" : " #808080"}`,
                        }}
                      />{" "}
                      {order?.delivered ? (
                        <>
                          <span>
                            {" "}
                            Delivered on{" "}
                            {moment(order?.deliveredAt).format(
                              "DD-MM-YYYY"
                            )}{" "}
                          </span>
                          <Tooltip title="Download Invoice">
                            <IconButton
                              onClick={() => {
                                navigate(`/invoices/${order?.id}`);
                              }}
                            >
                              <DownloadForOffline
                                sx={{
                                  fontSize: "1.5rem !important",
                                  color: "#cf5151",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <span>
                          {" "}
                          Order on{" "}
                          {moment(order?.orderDate).format("DD-MM-YYYY")}{" "}
                        </span>
                      )}
                    </div>
                    <h3 className="order-item-delivery-msg">
                      {order?.delivered
                        ? "Your order has been delivered successfully "
                        : order?.orderMessage}
                    </h3>

                    {order?.delivered && (
                      <div
                        className="rating-and-review-product-link flex-row align-items-center gap-1 "
                        onClick={() => {
                          setRateOrder(true);
                          setReviewId(order?.products?.productId);
                        }}
                      >
                        <Star />{" "}
                        <span className="flex-row align-items-center">
                          Rate & review this product
                        </span>
                      </div>
                    )}
                    {order?.delivered && rateOrder && (
                      <div className="rate-order flex-row align-items-center justify-content-center">
                        <div
                          className="rate-profile-inner-child flex-column gap-2"
                          ref={rateRef}
                        >
                          <div className="rate-by-star flex-column align-items-center gap-1">
                            <h3 className="rate-profile-inner-child-title">
                              Rate your order
                            </h3>

                            <span className="rate-review-star">
                              <Rating
                                name="simple-controlled"
                                value={rateValue}
                                onChange={(event, newValue) => {
                                  setRateValue(newValue);
                                }}
                              />
                            </span>
                          </div>
                          <div className="review-by-message w-100">
                            <TextField
                              placeholder="Write a review"
                              multiline={true}
                              rows={3}
                              className="w-100"
                              value={reviewMessage}
                              onChange={(e) => {
                                setReviewMessage(e?.target?.value);
                              }}
                            />
                          </div>
                          <div className="submit-review-btn flex-row align-items-center justify-content-center">
                            <Button onClick={handleReview}>
                              Submit Review
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </React.Fragment>
            );
          })
        ) : (
          <div
            className="flex-row align-items-center justify-content-center "
            style={{ minHeight: "50vh" }}
          >
            <div className="flex-col align-items-center justify-content-center">
              <Lottie options={notFoundLottie} height={300} width={300} />
              <h3 className="text-center">Empty...</h3>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

const Wishlist = () => {
  const { data, loading } = useWishlistData();
  const products = useProducts();
  const suppliers = useSuppliers();
  let isMounted = useIsMounted();
  const [wishlist, setWishlist] = useState([]);
  const [favoriteSuppliers, setFavoriteSuppliers] = useState([]);

  useEffect(() => {
    if (isMounted.current) {
      let wishListProduct = [];
      let favoriteSupplier = [];

      for (let i = 0; i < data?.length; i++) {
        if (data[i]?.type === "supplier") {
          let favSuppliers = suppliers?.data?.find((item) => {
            return item?.id === data[i]?.id;
          });
          favoriteSupplier.push(favSuppliers);
        } else {
          let favProducts = products?.data?.find((item) => {
            return item?.id === data[i]?.id;
          });
          wishListProduct.push(favProducts);
        }
      }

      setWishlist(wishListProduct);
      setFavoriteSuppliers(favoriteSupplier);
    }
  }, [isMounted, products?.data, data, suppliers?.data]);

  // console.log(wishlist);
  // console.log(favoriteSuppliers);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: emptyList,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="profile-wishlist-section">
      <div className="profile-my-wishlist-title">
        <h3>My Wishlist</h3>
      </div>

      <div className="my-wishlist-content">
        <Container>
          {loading ? (
            <h3 className="rate-profile-inner-child-title text-center ">
              Loading...
            </h3>
          ) : (
            <Grid
              container
              spacing={3}
              justifyContent="center"
              className="flex-row "
            >
              {favoriteSuppliers &&
                favoriteSuppliers?.length > 0 &&
                favoriteSuppliers?.map((data, index) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      key={index}
                      className="flex-row align-items-center justify-content-center"
                    >
                      <SupplierCards
                        id={data?.id}
                        img={data?.image}
                        name={data?.name}
                        location={data?.location}
                        rating={data?.rating}
                        minOrder={data?.minOrder}
                        inWishlist={true}
                      />
                    </Grid>
                  );
                })}

              {wishlist &&
                wishlist?.length > 0 &&
                wishlist?.map((data, index) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      key={index}
                      className="flex-row align-items-center justify-content-center"
                    >
                      <BasicCard data={data} inWishlist={true} />
                    </Grid>
                  );
                })}
              {wishlist?.length === 0 && favoriteSuppliers?.length === 0 && (
                <div
                  className="flex-row align-items-center justify-content-center "
                  style={{ minHeight: "50vh" }}
                >
                  <div className="flex-col align-items-center justify-content-center">
                    <Lottie options={notFoundLottie} height={300} width={300} />
                    <h3 className="text-center"> Your Wishlist is Empty </h3>
                  </div>
                </div>
              )}
            </Grid>
          )}
        </Container>
      </div>
    </section>
  );
};

const ReferEarn = () => {
  const { user } = useAppContext();

  const [referEmail, setReferEmail] = useState("");

  const copyToClipboard = async (e) => {
    try {
      await navigator.clipboard.writeText(user?.referralCode);
      Swal.fire({
        title: "Copied!",
        text: "Referral code has been copied to your clipboard",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      Swal.fire({
        title: "Failed to copy",
        text: "Please try again ",
        icon: "error",
      });
    }
  };

  const shareCode = () => {
    try {
      if (navigator?.canShare) {
        navigator
          ?.share({
            title: "Earn money on successful referral",
            text: "Use my referral code to sign up and get $10 ",
            url: `${window.location.origin}/signup?referralCode=${user?.referralCode}`,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Failed to share",
        text: "Please try again ",
        icon: "error",
      });
    }
  };

  const sendEmail = async () => {
    try {
      if (!referEmail) {
        Swal.fire({
          title: "Please enter email",
          text: "",
          icon: "error",
        });
        return;
      }
      const data = {
        to: referEmail,
        subject: "Referral code",
        content: `Use my referral code to sign up and get $10 ${window.location.origin}/signup?referralCode=${user?.referralCode}`,
      };

      const response = await fetch(
        `https://water-sy-api.herokuapp.com/api/send-mail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const json = await response.json();
      console.log(json);

      if (response.status === 200) {
        Swal.fire({
          title: "Email sent",
          text: "Email has been sent successfully",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Failed to send email",
          text: "Please try again ",
          icon: "error",
        });
      }
      setReferEmail("");
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Failed to send",
        text: "Please try again later",
        icon: "error",
      });
    }
  };

  return (
    <section className="profile-refer-earn-section">
      <Grid container className="profile-refer-earn-inner-container">
        <Grid item xs={12} sm={12} md={6}>
          <div className="refer-earn-left">
            <div className="refer-earn-left-heading">
              <h3 className="refer-earn-left-heading-h">
                {" "}
                More Then you Expect
              </h3>
              <p className="refer-earn-left-heading-p">
                Earn more by referring your friends and family Lorem ipsum dolor
                sit amet consectetur adipisicing elit. Impedit, eius!
              </p>
            </div>
            <div className="refer-earn-left-subheading">
              <h6 className="refer-earn-left-heading-h"> But even better</h6>
              <p className="refer-earn-left-heading-p">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe,
                dolor ea. Sapiente!
              </p>
            </div>
            <div className="refer-earn-link-form flex-column ">
              <div className="refer-earn-link-form-invite flex-column ">
                <div className="refer-earn-input flex-row align-items-center justify-content-between ">
                  <TextField
                    placeholder="Enter yours friend's email address"
                    value={referEmail}
                    type="email"
                    onChange={(e) => {
                      setReferEmail(e.target.value);
                    }}
                  />

                  <Button className="refer-btn" onClick={sendEmail}>
                    Invite
                  </Button>
                </div>
              </div>
              <p className="divide-or flex-row align-items-center justify-content-center">
                {" "}
                or{" "}
              </p>
              <div className="refer-earn-link-form-share-link flex-column gap-1 ">
                <div className="refer-earn-input flex-row align-items-center justify-content-between ">
                  <TextField
                    placeholder="Copy the code"
                    value={user?.referralCode}
                  />

                  <Button className="refer-btn" onClick={copyToClipboard}>
                    Copy
                  </Button>
                </div>

                <div className="refer-link-social-share flex-row align-items-center justify-content-center gap-1">
                  <p className="flex-row align-items-center">Share your link</p>
                  <div className="refer-link-social-share-icons flex-row align-items-center gap-1">
                    <span className="social-facebook flex-row justify-content-center align-items-center ">
                      <a
                        href={`https://www.facebook.com/sharer/sharer.php?text=Join me on ${window?.location?.origin} and get $10 when you sign up using my referral code ${user?.referralCode}
                        click here to sign up ${window?.location?.origin}/signup?referralCode=${user?.referralCode} `}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-row"
                      >
                        <Facebook />
                      </a>
                    </span>

                    <span className="social-twitter flex-row justify-content-center align-items-center ">
                      <a
                        href={`https://twitter.com/intent/tweet?text=Join me on ${window?.location?.origin} and get $10 when you sign up using my referral code ${user?.referralCode}
                        click here to sign up ${window?.location?.origin}/signup?referralCode=${user?.referralCode} `}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-row"
                      >
                        <Twitter />
                      </a>
                    </span>

                    <span className="social-whatsapp flex-row justify-content-center align-items-center ">
                      <a
                        href={`https://api.whatsapp.com/send?phone=&text=Join me on ${window?.location?.origin} and get $10 when you sign up using my referral code ${user?.referralCode}
                        click here to sign up ${window?.location?.origin}/signup?referralCode=${user?.referralCode} `}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-row"
                      >
                        <WhatsApp />
                      </a>
                    </span>
                    <span
                      className="social-linkedin flex-row justify-content-center align-items-center "
                      onClick={shareCode}
                      style={{ cursor: "pointer" }}
                    >
                      <Share />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={0} md={6}>
          <div className="refer-earn-right flex-row align-items-center justify-content-center">
            <img src={ReferBanner} alt="" className="refer-banner" />
          </div>
        </Grid>
      </Grid>
    </section>
  );
};

const Profile = ({ path }) => {
  const { user } = useAppContext();

  // console.log(path);

  const navPath = useMemo(() => {
    return [
      {
        icon: <AccountCircle />,
        label: "Profile",
        path: "/",
        component: <MyProfile />,
      },
      {
        icon: <ShoppingCart />,
        label: "My Orders",
        path: "/myorder",
        component: <MyOrder />,
      },
      {
        icon: <Favorite />,
        label: "Wishlist",
        path: "/wishlist",
        component: <Wishlist />,
      },

      {
        icon: <Redeem />,
        label: "Refer & Earn",
        path: "/refer",
        component: <ReferEarn />,
      },
    ];
  }, []);

  let [activeComp, setActiveComp] = useState(navPath[0].component);

  // useEffect(() => {
  //   setActiveMenu(
  //     currentUrl.path ? `${currentUrl}` : { path: navPath[0].path }
  //   );
  // }, [currentUrl]);

  // console.log(activeMenu);
  // useEffect(() => {

  //   });
  // }, [path, navPath]);

  useEffect(() => {
    navPath.forEach((item) => {
      if (item.path === path) {
        setActiveComp(item.component);
      }
    });
  }, [path, navPath]);

  const logOut = () => {
    signOut(auth)
      .then(() => {
        Navigate("/login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  return (
    <main>
      <section className="profile-main-section">
        <Container>
          <Grid container>
            <Grid
              item
              md={3}
              xs={0}
              sx={{ position: "relative" }}
              className="profile-sidebar-container"
            >
              <div className="profile-left-nav-grid flex-column">
                {user?.role === "super-admin" && (
                  <NavLink to={"/admin/dashboard"}>
                    <div
                      className={`profile-left-nav-grid-item flex-row align-items-center gap-1`}
                    >
                      <Dashboard />
                      <p>Dashboard</p>
                    </div>
                  </NavLink>
                )}
                {navPath.map((item, index) => {
                  return (
                    <NavLink
                      key={index}
                      to={
                        navPath[index].component
                          ? `/profile${item.path}`
                          : `${item.path}`
                      }
                    >
                      <div
                        className={`profile-left-nav-grid-item flex-row align-items-center gap-1 ${
                          path === item.path &&
                          "profile-left-nav-grid-item-active"
                        } `}
                        key={index}
                        onClick={() => {
                          setActiveComp(navPath[index].component);
                        }}
                      >
                        {item.icon}
                        <p>{item.label}</p>
                      </div>
                    </NavLink>
                  );
                })}
                <div
                  className={`profile-left-nav-grid-item flex-row align-items-center gap-1`}
                  onClick={logOut}
                >
                  <Logout />
                  <p>Logout</p>
                </div>
              </div>

              {/* <h1 className="profile-main">Hi User! Login</h1> */}
            </Grid>
            <Grid item md={9} xs={12}>
              <div className="profile-right-grid">{activeComp}</div>
            </Grid>
          </Grid>
        </Container>
      </section>
    </main>
  );
};

export default Profile;
